import React from 'react';
import PropTypes from 'prop-types';
import icons, { iconsList } from './icons';

const defaultPosition = {};

const BlinkingIcon = ({
  icon,
  size = 16,
  color,
  animationDuration = '2s',
  animationDelay = '',
  position: { top, left, right, bottom } = defaultPosition,
}) => {
  const IconComponent = icons[icon];

  return (
    <span
      className="ws-ui-blinking-icon"
      style={{ animationDuration, animationDelay, top, left, right, bottom }}
    >
      <IconComponent size={size} color={color} />
    </span>
  );
};

BlinkingIcon.propTypes = {
  icon: PropTypes.oneOf(iconsList).isRequired,
  color: PropTypes.string.isRequired,
  animationDuration: PropTypes.string,
  animationDelay: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  position: PropTypes.shape({
    top: PropTypes.string,
    bottom: PropTypes.string,
    left: PropTypes.string,
    right: PropTypes.string,
  }),
};

export default BlinkingIcon;
